<template>
    <div class="r_edit_content r_edit_content02" v-loading="formLoading">
        <!-- 基础信息 -->
        <div class="f_form_btn">
            <p class="r_edit_title">基础信息</p>
            <div class="r_title_btns">
                <!-- <el-button type="info" size="small" @click="isDetail = true">取消</el-button> -->
                <el-upload v-if="!isDetail" class="p_vita_upload" action="#" :on-change="handleChangeVita" :on-remove="handleRemoveVita" :auto-upload="false" :multiple="false" :limit="1" :on-exceed="handleExceedVita" :file-list="vitafileList">
                    <el-button size="small" type="primary" plain>上传简历附件</el-button>
                </el-upload>
                <el-button v-if="isDetail&&(!this.isNull(basicQuery.StrResumefileUrl))" type="primary" plain size="small" @click="preVitaViewFile">下载简历附件</el-button>
                <el-button v-if="editTxt == '编辑'" type="primary" size="small" @click="editHandle">编辑</el-button>
                <el-button v-if="editTxt == '保存编辑'" type="primary" @click="saveHandle('all')" size="small">保存编辑</el-button>
            </div>
        </div>
        <div class="r_basic_content">
            <div class="r_basic_box">
                <div class="r_basic_left">
                    <!-- 个人基本信息展示模块 -->
                    <div class="r_lefts" v-if="isDetail">
                        <div class="r_left_pic">
                            <el-image class="pic_item" :src="!isNull(basicQuery.Stravatar)?basicQuery.Stravatar:basicQuery.BolUserSex=='女'?womanStravatar:manStravatar" fit="contain"></el-image>
                        </div>
                        <div class="r_info_box">
                            <div class="l_info_box">
                                <div class="r_left_info">
                                    <div class="r_qiwei">
                                        <p>{{basicQuery.StrUserName}}</p>
                                        <el-image v-if="basicQuery.StrIsqwfri == '是'" :src="urlWechat" fit="cover"></el-image>
                                    </div>
                                    <!-- <p class="r_txts">{{basicQuery.StrUserJobhunt}}</p> -->
                                    <p class="r_txts">
                                        <span class="r_txt01">{{basicQuery.StrEduLvl}}</span>
                                        <span class="r_txt01">{{basicQuery.BolUserSex}}</span>
                                        <span class="r_txt01">{{basicQuery.StrUsernation}}</span>
                                        <span class="r_txt02" v-if="!isNull(basicQuery.StrUserAge)">{{basicQuery.StrUserAge}}岁</span>
                                    </p>
                                    <p class="r_txts" v-if="!isNull(basicQuery.StrUserAdd)">
                                        <span class="r_txt01 com_title">居住地</span>
                                        <span class="r_txt03">{{basicQuery.StrUserAdd}}</span>
                                    </p>
                                </div>
                                <div class="r_left_info">
                                    <p class="r_txts" v-if="!isNull(basicQuery.StrMobile)" style="margin-top: 0;">
                                        <i class="el-icon-phone"></i>
                                        <span class="r_txt04">{{basicQuery.StrMobile}}</span>
                                    </p>
                                    <p class="r_txts r_txts01">
                                        <span class="r_txt01 com_title">黑名单</span>
                                        <span class="r_txt01">{{isNull(basicQuery.StrIsBlack)?'否':basicQuery.StrIsBlack}}</span>
                                    </p>
                                    <p class="r_txts r_txts01" v-if="basicQuery.StrIsBlack == '是'">
                                        <span class="r_txt01 com_title">黑名单原因</span>
                                        <span class="r_txt01">{{basicQuery.StrBlackReason}}</span>
                                    </p>
                                    <p class="r_txts" v-if="!isNull(basicQuery.Strother)">
                                        <span class="r_txt01 com_title">政治面貌</span>
                                        <span class="r_txt03">{{basicQuery.Strother}}</span>
                                    </p>
                                    <p class="r_txts" v-if="!isNull(basicQuery.StrNativePlace)">
                                        <span class="r_txt01 com_title">籍贯</span>
                                        <span class="r_txt03">{{basicQuery.StrNativePlace}}</span>
                                    </p>
                                </div>
                            </div>
                            <p v-if="!isNull(strIdCardTxt)" class="id_txt">
                                <span class="r_txt01 com_title">身份证</span>
                                <span class="r_txt03">{{strIdCardTxt}}</span>
                            </p>
                        </div>
                    </div>
                    <!-- 个人基本信息编辑模块 -->
                    <el-form v-show="!isDetail" :inline="true" :rules="basicRules" ref="enterResumeForm" :model="basicQuery" class="re_dtl_form re_dtl_form01" label-width="90px">
                        <!-- <el-form-item>
                            <el-upload class="avatar-uploader" action=""
                                :on-change="upLoad"
                                :show-file-list="false"
                                :auto-upload="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                            >
                                <img v-if="staffQuery.Stravatar" :src="cloudimg + staffQuery.Stravatar"
                                class="avatar"
                                />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item> -->
                        <el-form-item label="姓名:" prop="StrUserName">
                            <el-input v-model="basicQuery.StrUserName" size="small" :disabled="isDetail" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式:" prop="StrMobile">
                            <el-input v-model="basicQuery.StrMobile" size="small" disabled clearable></el-input>
                        </el-form-item>
                        <el-form-item label="年龄:" prop="StrUserAge">
                            <el-input v-model="basicQuery.StrUserAge" size="small" :disabled="isDetail" type="number" oninput="value=value.replace(/\D+/g,'')" min="1" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="性别:" prop="BolUserSex">
                            <el-select v-model="basicQuery.BolUserSex" placeholder="" :disabled="isDetail" size="small">
                                <el-option label="女" value="女"></el-option>
                                <el-option label="男" value="男"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="简历来源:" prop="StrSource">
                            <el-select v-model="basicQuery.StrSource" placeholder="" size="small" >
                                <el-option v-for="item in originList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="居住地:" prop="StrUserAdd">
                            <el-input v-model="basicQuery.StrUserAdd" :disabled="isDetail" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="文化程度:" prop="StrEduLvl">
                            <el-select v-model="basicQuery.StrEduLvl" placeholder="" size="small" :disabled="isDetail">
                            <el-option v-for="item in eduList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="籍贯:" prop="StrNativePlace">
                            <el-input v-model="basicQuery.StrNativePlace" :disabled="isDetail" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="政治面貌:" prop="Strother">
                            <el-select v-model="basicQuery.Strother" placeholder="" size="small" :disabled="isDetail">
                                <el-option v-for="item in politicsList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="民族:" prop="StrUsernation">
                            <el-select v-model="basicQuery.StrUsernation" filterable placeholder="" size="small" >
                                <el-option v-for="item in nationList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                            </el-select>
                            <!-- <el-input v-model="basicQuery.StrUsernation" :disabled="isDetail" size="small" clearable></el-input> -->
                        </el-form-item>
                        <el-form-item label="是否黑名单:" prop="StrIsBlack">
                            <el-select v-model="basicQuery.StrIsBlack" :disabled="isDetail" placeholder="" size="small" @change="blackChange">
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="黑名单标签:" prop="StrBlackReason" v-if="basicQuery.StrIsBlack == '是'">
                            <el-select v-model="basicQuery.StrBlackReason" :disabled="isDetail" placeholder="" size="small" clearable>
                                <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="r_basic_right" v-if="isDetail">
                    <div v-if="pageTitle.indexOf('资源')>-1">
                        <p class="r_txt04">{{basicQuery.StrUserJobhunt}}</p>
                    </div>
                    <div v-else>
                        <p class="r_txt04" v-if="basicQuery.StrState == '入职'">在职</p>
                        <p class="r_txt04" v-else-if="basicQuery.StrState == '终止'">{{basicQuery.StrUserJobhunt}}</p>
                        <p class="r_txt04" v-else>{{basicQuery.StrState}}</p>
                    </div>
                    <!-- <p class="r_txt05">{{basicQuery.DtupdateDate}}</p> -->
                </div>
            </div>
            <!-- 标签 -->
            <div class="r_label_box">
                <div class="r_label_left">
                    <div class="l_box">
                        <!-- <p v-if="!isNull(lPubDialogList)" class="r_txt07">全局标签:</p> -->
                        <div class="r_label_list">
                            <div class="r_label_item" v-for="(item,index) in lPubDialogList" :key="index">{{item.LableName}}</div>
                            <div class="r_label_item" v-for="(item,index) in lPriDialogList" :key="index">{{item.LableName}}</div>
                            <i class="el-icon-circle-plus-outline icon_add" title="打标签" @click="addLabelHandle"></i>
                        </div>
                        <!-- <p v-if="!isNull(lPriDialogList)" class="r_txt07">私有标签:</p> -->
                        <!-- <div class="r_label_list">
                            <div class="r_label_item" v-for="(item,index) in lPriDialogList" :key="index">{{item.LableName}}</div>
                            <i class="el-icon-circle-plus-outline icon_add"></i>
                        </div> -->
                    </div>
                    <div class="r_label_btn">
                        <!-- <el-button v-if="!isDetail" type="primary" size="mini" @click="addLabelHandle">更新标签</el-button> -->
                    </div>
                </div>
                <div class="r_label_right">
                    <p class="r_txt06" v-if="!isNull(basicQuery.StrSource)">
                        <span class="r_txt01">简历来源:</span>
                        <span>{{basicQuery.StrSource}}</span>
                    </p>
                    <p class="r_txt06" v-if="!isNull(basicQuery.enterUser)">
                        <span class="r_txt01">简历创建人</span>
                        <span>{{basicQuery.enterUser}}</span>
                    </p>
                    <p class="r_txt05">{{isNull(basicQuery.enterDate)?'':basicQuery.enterDate.replace('T',' ')}}</p>
                </div>
            </div>
        </div>
        <!-- 求职意向 -->
        <div class="f_form_btn">
            <p class="r_edit_title">求职意向</p>
        </div>
        <!-- 未编辑状态内容 -->
        <div class="inten_box" v-if="isDetail">
            <div class="inten_list">
                <div class="inten_item">
                    <div class="inten_item_left">意向岗位:</div>
                    <div class="inten_item_right">{{basicQuery.StrJobInf}}</div>
                </div>
                <div class="inten_item">
                    <div class="inten_item_left">求职岗位类型:</div>
                    <div class="inten_item_right">{{basicQuery.StrJobType}}</div>
                </div>
                <div class="inten_item">
                    <div class="inten_item_left">站班/坐班:</div>
                    <div class="inten_item_right">{{basicQuery.Workingposition}}</div>
                </div>
                <div class="inten_item">
                    <div class="inten_item_left">意向地区:</div>
                    <div class="inten_item_right">{{basicQuery.StrUserCity}}</div>
                </div>
                <div class="inten_item">
                    <div class="inten_item_left">住宿需求:</div>
                    <div class="inten_item_right">{{basicQuery.StrAccomreq}}</div>
                </div>
                <div class="inten_item">
                    <div class="inten_item_left">班次需求:</div>
                    <div class="inten_item_right">{{basicQuery.WorkingShift}}</div>
                </div>
                <div class="inten_item">
                    <div class="inten_item_left">期望薪资:</div>
                    <div class="inten_item_right">{{isNull(basicQuery.salary1)?'':basicQuery.salary1+'-'+basicQuery.salary2}}</div>
                </div>
                <div class="inten_item">
                    <div class="inten_item_left">吃饭需求:</div>
                    <div class="inten_item_right">{{basicQuery.StrDinreq}}</div>
                </div>
                <div class="inten_item">
                    <div class="inten_item_left">社保需求:</div>
                    <div class="inten_item_right">{{basicQuery.Strsocial}}</div>
                </div>
            </div>
        </div>
        <el-form v-show="!isDetail" :inline="true" :rules="basicRules" ref="enterResumeForm" :model="basicQuery" class="re_dtl_form re_dtl_form01" label-width="100px">
            <el-form-item label="意向岗位:" prop="posCategoryList">
                <el-cascader ref="poSectionArr" size="small" placeholder=""
                v-model="basicQuery.posCategoryList" :props="propPosition" clearable :disabled="isDetail"
                :options="intendedPost"
                @change="poSectionChange"></el-cascader>
            </el-form-item>
            <el-form-item label="求职岗位类型:">
                <el-select filterable v-model="basicQuery.StrJobType" placeholder="" size="small" :disabled="isDetail">
                <el-option label="长期工" value="长期工"></el-option>
                <el-option label="临时工" value="临时工"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="站班/坐班:">
                <el-select v-model="basicQuery.Workingposition" placeholder="" size="small" :disabled="isDetail">
                    <el-option v-for="(item, index) in workList" :key="index" :label="item.Name" :value="item.Name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="意向地区:" prop="strCityCode">
                <el-cascader :props="propsAddress" ref="cascaderArr" clearable filterable placeholder="" size="small" :disabled="isDetail" v-model="basicQuery.strCityCode" :options="provinces" @change="changeArea"></el-cascader>
            </el-form-item>
            <el-form-item label="住宿需求:" prop="StrAccomreq">
                <el-select v-model="basicQuery.StrAccomreq" size="small" placeholder="" :disabled="isDetail">
                    <el-option label="需要" value="需要"></el-option>
                    <el-option label="不需要" value="不需要"></el-option>
                    <!-- <el-option v-for="item in stayList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option> -->
                </el-select>
            </el-form-item>
            <el-form-item label="班次需求:" prop="WorkingShift">
                  <el-select v-model="basicQuery.WorkingShift" filterable clearable
                      :disabled="isDetail" size="small" placeholder="">
                      <el-option
                      v-for="(item, index) in shiftList"
                      :key="index"
                      :label="item.Name"
                      :value="item.Name">
                      </el-option>
                  </el-select>
            </el-form-item>
            <el-form-item label="期望薪资:" prop="StrUserExpectSa">
                <div class="r_line_box">
                <el-input v-model="basicQuery.salary1" size="small" type="number" min="0" :disabled="isDetail" clearable class="r_line_input1"></el-input>
                <span class="r_line_txt"></span>
                <el-input v-model="basicQuery.salary2" size="small" type="number" min="0" :disabled="isDetail" clearable class="r_line_input2"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="吃饭需求:" prop="StrDinreq">
                <el-select v-model="basicQuery.StrDinreq" size="small" placeholder="" :disabled="isDetail">
                    <el-option label="需要" value="需要"></el-option>
                    <el-option label="不需要" value="不需要"></el-option>
                    <!-- <el-option v-for="item in eatList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option> -->
                </el-select>
            </el-form-item>
            <el-form-item label="社保需求:" prop="Strsocial">
                <el-select v-model="basicQuery.Strsocial" size="small" placeholder="" :disabled="isDetail">
                    <el-option v-for="item in socialList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <!-- 能力 -->
        <div class="f_form_btn">
            <p class="r_edit_title">能力</p>
        </div>
        <div class="r_spend_box">
            <div class="r_spend_list">
                <p class="r_spend_title" :style="isDetail?'margin-top:0;':'margin-top:4px;'">技能</p>
                <div class="r_spend_right">
                    <div class="r_spend_skill">
                        <div class="r_spend_txts">
                            <div class="r_spend_model" v-for="(item, index) in skillData" :key="index">
                                <p>{{item.StrkillName}}</p>
                                <i v-if="!isDetail" class="el-icon-error" @click="dltAllHandle(item.Strkillid,'kill')" title="删除"></i>
                            </div>
                        </div>
                        <div class="r_spend_btn">
                            <el-button v-if="!isDetail" type="primary" size="mini" @click="addSkillHandle">新增技能</el-button>
                        </div>
                    </div>
                    <!-- 新增表单 -->
                    <div class="r_spend_form">
                        <!-- <el-form ref="skillform" :model="skillform" label-width="50px"> -->
                            <div v-for="(item, index) in skillList" :key="index" class="s_content">
                                <!-- <el-form-item label="" prop=""> -->
                                    <div class="r_spend_item01">
                                        <el-input v-model="item.StrkillName" placeholder="请输入技能" size="small" clearable class="s_input"></el-input>
                                        <i class="el-icon-delete-solid dlt_icon" title="删除" @click="dltSpendHandle(skillList,index)"></i>
                                        <i class="el-icon-circle-check dlt_icon" title="新增" @click="saveHandle('one')"></i>
                                        <!-- <el-button type="danger" size="mini" @click="dltSpendHandle(skillList,index)" style="margn-left:5px;">删除</el-button> -->
                                    </div>
                                <!-- </el-form-item> -->
                            </div>
                        <!-- </el-form> -->
                    </div>
                </div>
            </div>
            <div class="r_spend_list">
                <p class="r_spend_title" :style="isDetail?'margin-top:0;':'margin-top:4px;'">证书</p>
                <div class="r_spend_right">
                    <div class="r_spend_skill">
                        <div class="r_spend_txts">
                            <div class="r_spend_model" v-for="(item, index) in certData" :key="index">
                                <p>{{item.StrkillName}}</p>
                                <p class="s_file_txt" v-if="!isNull(item.Enclosure)" @click="downloadFile(item.Enclosure)">附件</p>
                                <i v-if="!isDetail" class="el-icon-error" @click="dltAllHandle(item.Strkillid,'kill')" title="删除"></i>
                            </div>
                        </div>
                        <div class="r_spend_btn">
                            <el-button v-if="!isDetail" type="primary" size="mini" @click="addCertHandle">新增证书</el-button>
                        </div>
                    </div>
                    <!-- 新增表单 -->
                    <div class="r_spend_form">
                        <div v-for="(item, index) in certList" :key="index" class="s_content">
                            <div class="r_spend_item01">
                                <el-cascader :options="certificateList" size="small" ref="certificate" filterable :show-all-levels="false" v-model="item.StrkillNameTxt" @change="((val)=>{changeCert(val, item)})" :props="{
                                value:'Name',label:'Name'
                                }" clearable></el-cascader>
                                <!-- <el-input v-model="item.StrkillName" placeholder="请输入证书" size="small" clearable class="s_input"></el-input> -->
                                <el-upload
                                    class="p_plan_upload"
                                    accept=".doc,.docx,.PDF,.xlsx,.xls,.jpg,.jpeg,.png"
                                    action="#"
                                    :on-change="(file, fileList)=>{return handleReceiptChange(file, fileList, index)}"
                                    :on-remove="(file, fileList)=>{return handleReceiptRemove(file, fileList, index)}"
                                    :auto-upload="false"
                                    :multiple="false"
                                    :limit="1"
                                    :on-exceed="handleExceed"
                                    :file-list="item.fileReceiptList">
                                    <el-button size="small" type="text">点击上传</el-button>
                                    <!-- <div slot="tip" class="el-upload__tip">只能上传word文件</div> -->
                                </el-upload>
                                <i class="el-icon-delete-solid dlt_icon" title="删除" @click="dltSpendHandle(certList,index)"></i>
                                <i class="el-icon-circle-check dlt_icon" title="新增" @click="saveHandle('one')"></i>
                                <!-- <el-button style="margin-left:5px;" type="danger" size="mini" @click="dltSpendHandle(certList,index)">删除</el-button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 教育经历 -->
        <div class="f_form_btn">
            <p class="r_edit_title">教育经历</p>
        </div>
        <div class="r_spend_box">
            <div class="r_btn_box">
                <el-button v-if="!isDetail" type="primary" size="mini" @click="addEduHandle">新增教育经历</el-button>
            </div>
            <el-table :data="eduData" style="width: 100%">
                <el-table-column align="center" prop="Strschool" label="学校" min-width="110">
                </el-table-column>
                <el-table-column align="center" prop="Strmajor" label="专业" min-width="110">
                </el-table-column>
                <el-table-column align="center" min-width="110" label="时间">
                    <template scope="{row}">
                        <span v-if="!isNull(row.Stredutimestart)">{{row.Stredutimestart.substring(0,10) + '~' + row.Stredutimeend.substring(0,10)}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" min-width="110" prop="address" label="操作" v-if="!isDetail">
                    <template scope="{row}">
                        <i class="el-icon-delete-solid dlt_icon" style="margin-left:0;" title="删除" @click="dltAllHandle(row.Streduid,'edu')"></i>
                        <!-- <el-button type="danger" size="mini" @click="dltAllHandle(row.Streduid,'edu')">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 新增表单 -->
            <div class="r_spend_form">
                <div v-for="(item, index) in eduExpList" :key="index" class="s_content">
                    <div class="r_spend_item01">
                        <el-input v-model="item.Strschool" placeholder="请输入学校" size="small" clearable class="s_input"></el-input>
                        <el-input v-model="item.Strmajor" placeholder="请输入专业" size="small" clearable class="s_input"></el-input>
                        <el-date-picker v-model="item.StrDate" value-format="yyyy-MM-dd" size="small"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <i class="el-icon-delete-solid dlt_icon" title="删除" @click="dltSpendHandle(eduExpList,index)"></i>
                        <i class="el-icon-circle-check dlt_icon" title="新增" @click="saveHandle('one')"></i>
                        <!-- <el-button type="danger" size="mini" @click="dltSpendHandle(eduExpList,index)">删除</el-button> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 工作经历 -->
        <div class="f_form_btn">
            <p class="r_edit_title">工作经历</p>
        </div>
        <div class="r_spend_box">
            <div class="r_btn_box">
                <el-button v-if="!isDetail" type="primary" size="mini" @click="addWorkHandle">新增工作经历</el-button>
            </div>
            <el-table :data="workData" style="width: 100%">
                <el-table-column align="center" prop="StrProName" label="公司" min-width="110">
                </el-table-column>
                <el-table-column align="center" prop="StrJobInf" label="岗位" min-width="110">
                </el-table-column>
                <el-table-column align="center" min-width="150" prop="address" label="时间">
                    <template scope="{row}">
                        <span v-if="!isNull(row.Strworktimestart)">{{row.Strworktimestart.substring(0,10) + '~' + row.Strworktimeend.substring(0,10)+ '(在职' + row.Strworktime + '天)'}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" min-width="110" prop="StrRemark" label="离职原因">
                </el-table-column>
                <el-table-column align="center" min-width="110" label="操作" v-if="!isDetail">
                    <template scope="{row}">
                        <i class="el-icon-delete-solid dlt_icon" style="margin-left:0;" title="删除" @click="dltAllHandle(row.Strworkid,'work')"></i>
                        <!-- <el-button type="danger" size="mini" @click="dltAllHandle(row.Strworkid,'work')">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 新增表单 -->
            <div class="r_spend_form">
                <div v-for="(item, index) in workExpList" :key="index" class="s_content">
                    <div class="r_spend_item01">
                        <el-input v-model="item.StrProName" placeholder="请输入公司" size="small" clearable class="s_input"></el-input>
                        <el-input v-model="item.StrJobInf" placeholder="请输入岗位" size="small" clearable class="s_input"></el-input>
                        <el-date-picker v-model="item.StrDate" value-format="yyyy-MM-dd" size="small"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <el-input v-model="item.StrRemark" placeholder="请输入离职原因" size="small" clearable class="s_input"></el-input>
                        <i class="el-icon-delete-solid dlt_icon" title="删除" @click="dltSpendHandle(workExpList,index)"></i>
                        <i class="el-icon-circle-check dlt_icon" title="新增" @click="saveHandle('one')"></i>
                        <!-- <el-button type="danger" size="mini" @click="dltSpendHandle(workExpList,index)">删除</el-button> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加标签弹框 -->
        <el-dialog title="编辑标签" :visible.sync="addlabelVisible" width="700px" class="res_dialog">
            <div class="r_label_box" v-loading="laloading">
                <el-tabs v-model="labelActiveName" @tab-click="handleLabelClick">
                <el-tab-pane label="全局标签" name="全局标签">
                    <div class="dia_label_box">
                    <div class="dia_label_item" v-for="item in publicList" :key="item.LbGroup.Id">
                        <div class="dia_groupname">{{item.LbGroup.LableName}}</div>
                        <el-checkbox-group v-model="wholeCheckList" @change="dPubEnterHandle">
                            <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                            <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    </div>
                </el-tab-pane>
                <!-- <el-tab-pane label="私人标签" name="私人标签">
                    <div class="dia_label_box">
                    <div class="dia_label_item" v-for="item in privateList" :key="item.LbGroup.Id">
                        <div class="dia_groupname">{{item.LbGroup.LableName}}</div>
                        <el-checkbox-group v-model="wholeCheckList2" @change="dPraEnterHandle">
                            <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                            <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    </div>
                </el-tab-pane> -->
                </el-tabs>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                @click="addlabelVisible = false"
                size="small"
                >取消</el-button>
                <el-button type="primary"
                @click="saveLabelHandle()"
                size="small"
                >保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import xz from "./../../../common";
import moment from 'moment'
export default {
    data() {
        var validatePhone = (rule, value, callback) => {
            const phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
            // console.log('validatePhone',value)
            if (value.length == 11 && phoneReg.test(value)) {
                //校验通过
                callback()
            } else {
                callback(new Error('请输入正确的手机号'))
            }
        }
        return {
            strIdCardTxt:'',//身份证
            // 下载文件路径
            tablePath: this.$store.state.EMP.tablePath,
            docPath: this.$store.state.EMP.docPath,
            // 默认头像
            defaultPic: require(("./../../../assets/images/psn.png")),
            manStravatar:this.$store.state.EMP.imgPath + '/images/man.jpg',
            womanStravatar:this.$store.state.EMP.imgPath + '/images/woman.jpg',
            // 简历来源
            originList:[],
            // 是否包吃
            eatList:[],
            //是否包住
            stayList: [],
            //学历要求
            eduList: [],
            nationList:[],
            // 政治面貌
            politicsList:[],
            // 黑名单的标签
            blackLabelList:[],
            // 录入简历参数
            basicQuery:{
                natureId:'', //自然人ID
                ResumeId: '', //简历ID
                StrUserName: '', //姓名
                StrMobile: '', //联系方式
                StrWorkState: '', //在离职状态
                BolUserSex: '', //性别
                StrUserAge: '', //年龄
                StrNativePlace: '', //户籍
                StrEduLvl: '', //学历
                StrJobInf: '', //意向岗位
                StrCategoryIds: '', //意向岗位id
                // 选中的意向岗位
                posCategoryList: [],
                StrUserCity: '', //求职城市
                StrUserAdd: '', //居住地
                StrUserCityCode: '', //求职城市code
                StrSource: '', //来源
                StrUserExpectSa: '', //期望薪资
                salary1: '',
                salary2: '',
                StrRemark: '', //备注
                StrlateCompany: '', //最近入职项目
                DtlateInducDate: '', //最近入职时间
                DtlatequitDate: '', //最近离职时间
                StrquitReason: '', //离职原因
                StrUserJobhunt: '', //求职意向
                StrPsnIsType: '', //是否公海 1 公海 0私人
                enterUser:'', //录入人
                enterDate:'', //录入时间
                StrJobType:'', //岗位类型
                StrState:'', //状态
                DtupdateDate:'',//最新更新时间
                // 选中的地区code
                strCityCode: [],
                //拓展
                StrIsBlack: '', //是否黑名单
                StrBlackReason: '', //黑名单原因
                StrUsernation: '', //民族
                Strskill: '', //技能
                Strcertificate: '', //证书
                StrAccomreq: '', //住宿要求
                StrDinreq: '', //吃饭要求
                StrIsqwfri: '', //是否企微好友
                StrCont1: '', //拓展1
                StrCont2: '',
                StrCont3: '',
                StrCont4: '',
                StrCont5: '',
                StrCont6: '',
                StrCont7: '',
                StrCont8: '',
                StrCont9: '',
                StrCont10: '',
                Strsocial:'',//社保需求
                Strother:'', // 政治面貌
                WorkingShift: '', // 班次
                Workingposition: '', // 站班/坐班
                StrResumefile:'', // 简历文件名称
                StrResumefileUrl:'' // 简历文件路径
            },
            // 标签弹框公有标签列表
            lPubDialogList:[],
            // 标签弹框私有标签列表
            lPriDialogList:[],
            // 添加标签弹框选中的标签
            diaTagChecks:[],
            // 自定义 级联选择props
            propPosition: { label: 'strParametername', value: 'strParameterid', children: 'children', checkStrictly: true },
            // 规则
            basicRules: {
                StrUserName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                StrMobile: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                    { validator: validatePhone, trigger: ['blur'] }
                ],
                BolUserSex: [
                    { required: true, message: '请选择性别', trigger: 'change' }
                ],
                StrUserAge: [
                    { required: true, message: '请输入年龄', trigger: 'blur' }
                ],
                StrSource: [
                    { required: true, message: '请选择简历来源', trigger: 'change' }
                ],
                strCityCode: [
                    { type: 'array', required: true, message: '请选择意向地区', trigger: 'change' }
                ],
                posCategoryList: [
                    { type: 'array', required: true, message: '请选择意向岗位', trigger: 'change'}
                ]
            },
            // 编辑按钮文字
            editTxt:'编辑',
            isDetail: true,
            urlWechat: require("./../../../assets/images/qwei.png"),
            addlabelVisible: false,
            laloading: false,
            // 全局标签
            publicList: [],
            // 私人标签
            privateList: [],
            // 弹框选中的全局标签
            dCheckCommonLabelList:[],
            // 弹框选中的私有标签
            dCheckPriLabelList:[],
            postList: [],
            // 意向岗位列表
            intendedPost: [],
            // 班次
            shiftList: [],
            // 社保需求列表
            // socialList:['正常缴纳','不缴纳','部分缴纳','异地缴纳'],
            socialList:['需要','不需要'],
            // 站班坐班
            workList: [],
            labelActiveName: '全局标签',
            // 省份
            provinces: [],
            propsAddress: {
                checkStrictly: true,
                value: 'Id',
                label: 'Name',
                children: 'children'
            },
            addlabelVisible: false,
            roleType: '',
            wholeCheckList: [],
            wholeCheckList2: [],
            // 技能列表
            skillData: [],
            // 新增的技能列表
            skillList: [],
            // 证书列表
            certData:[],
            // 新增证书列表
            certList: [],
            // 上传证书列表
            fileReceiptList: [],
            // 教育经历列表
            eduData:[],
            // 新增的教育经历列表
            eduExpList:[],
            // 工作经历列表
            workData:[],
            // 新增的工作经历列表
            workExpList:[],
            // 删除参数
            dltQuery:{
                strid:'',
                strtype:'' //kill  技能  edu 教育  work 工作
            },
            formLoading:false,
            saveType:'',
            pageTitle:'',
            vitafileList:[],//简历附件
            headUrl: location.origin.indexOf('localhost') > -1 ? 'https://dev.joball.net/clouddoc/' : location.origin + '/clouddoc/',
            certificateList: []//证书
        }
    },
    created() {
        this.basicQuery.ResumeId = this.$route.query.id
        this.pageTitle = this.$route.query.pageTitle
        // 获取省份
        this.getprovinces()
        this.getTreestr()
        // 获取详情
        this.getResumeDtl(this.basicQuery.ResumeId)
         // 获取标签详情
        this.getresumelabelLists(this.basicQuery.ResumeId)
        this.getdictdatalistbyid('70')
        this.getdictdatalistbyid('67')
        // // 是否包住
        // this.getdictdatalistbyid('44')
        // // 是否包吃
        // this.getdictdatalistbyid('57')
        // 简历来源
        this.getdictdatalistbyid('118')
        // 学历要求
        this.getdictdatalistbyid('141')
        // 民族要求
        this.getdictdatalistbyid('253')
        // 政治面貌
        this.getdictdatalistbyid('160')
        // 黑名单标签
        this.getdictdatalistbyid('132')
        // 证书列表
        this.GetDictDataTreeListById(188, 'certificateList');
    },
    methods:{
        // 预览简历附件
        preVitaViewFile() {
            let url = this.basicQuery.StrResumefileUrl
            let file = this.headUrl + url;
            let lastIndex = file.lastIndexOf(".");
            let suffix = file.substring(lastIndex + 1);
            //文件格式是word文档、ppt、excel文件文件时
            if (suffix == 'doc' || suffix == 'docx' || suffix == 'ppt' || suffix == 'xls' || suffix == 'xlsx') {
            let fileUrl = encodeURIComponent(file)
            //使用Office Web查看器
            let officeUrl = 'http://view.officeapps.live.com/op/view.aspx?src=' + fileUrl
            window.open(officeUrl, '_target');
            } else {
            //其他文件格式比如pdf、图片、html
            window.open(file);
            }
        },
        handleRemoveDemFile(file, fileList) {
            this.basicQuery.StrResumefile = "";
            this.basicQuery.StrResumefileUrl = "";
            this.vitafileList = []
        },
        //简历附件
        handleChangeVita(file) {
            // console.log('file',file)
            let formData = new FormData();
            formData.append("action", "save");
            formData.append("pagename", "bdocinf");
            formData.append("userid", Cookies.get("userid-b"));
            formData.append("entid", Cookies.get("userid-b"));
            formData.append("entPicFile", file.raw, file.name);
            this.basicQuery.StrResumefile = file.name;
            xz.uploadCert(formData).then((res) => {
                if (res) {
                    // console.log('jj',res)
                    this.basicQuery.StrResumefileUrl = res;
                } else {
                    this.$message("文件上传失败,请稍后再试");
                }
            });
        },
        handleExceedVita() {
            this.$message.warning(`当前限制选择上传 1 个文件`);
        },
        //删除简历附件
        handleRemoveVita() {
            this.basicQuery.StrResumefile = "";
            this.basicQuery.StrResumefileUrl = "";
            this.vitafileList = []
        },
        // 证书选择
        changeCert(val,item){
            // console.log('pp',val,item)
            if(!this.isNull(val)){
                item.StrkillName = val[val.length-1]
            }else{
                item.StrkillName = ''
            }
            // console.log('pp',val,item)
        },
        // 黑名单选择
        blackChange(val){
            if(val == '否'){
                this.basicQuery.StrBlackReason = ''
            }
        },
        // 保存编辑 type:all-所有 one-单个保存
        saveHandle(types){
            this.saveType = types
            this.basicQuery.StrCategoryIds = this.basicQuery.posCategoryList.toString()
            if(this.isNull(this.basicQuery.salary1)&&this.isNull(this.basicQuery.salary2)){
                this.basicQuery.StrUserExpectSa = ''
            }else if(!this.isNull(this.basicQuery.salary1)&&this.isNull(this.basicQuery.salary2)){
                this.$message({ type: 'warning', message: '请填写最高期望薪资' })
                return false
            }else if(this.isNull(this.basicQuery.salary1)&&!this.isNull(this.basicQuery.salary2)){
                this.$message({ type: 'warning', message: '请填写最低期望薪资' })
                return false
            }else if(Number(this.basicQuery.salary1)>Number(this.basicQuery.salary2)){
                this.$message({ type: 'warning', message: '最低期望薪资不能高于最高薪资' })
                return false
            }else{
                this.basicQuery.StrUserExpectSa = this.basicQuery.salary1+'-'+this.basicQuery.salary2
            }
            // 过滤掉空值
            this.skillList = this.skillList.filter(item => !this.isNull(item.StrkillName))
            this.certList = this.certList.filter(item => !this.isNull(item.StrkillName))
            this.eduExpList = this.eduExpList.filter(item => !this.isNull(item.Strschool))
            this.workExpList = this.workExpList.filter(item => !this.isNull(item.StrProName))
            this.eduExpList.forEach((item,index) => {
                if(!this.isNull(item.StrDate)){
                    item.Stredutimestart = item.StrDate[0]
                    item.Stredutimeend = item.StrDate[1]
                }
            })
            this.workExpList.forEach((item,index) => {
                if(!this.isNull(item.StrDate)){
                    let m1 = moment(item.StrDate[0])
                    let m2 = moment(item.StrDate[1])
                    // let duration = moment.duration(m2.diff(m1))
                    // let {_data} = duration //   "年:" + _data.years,
                    // let year = _data.years==0?'':(_data.years+'年')
                    // let months = _data.months==0?'':(_data.months+'月')
                    // let days = _data.days==0?'':(_data.days+'天')
                    // let hours = _data.hours==0?'':(_data.hours+'时')
                    // let minutes = _data.minutes==0?'':(_data.minutes+'分')
                    item.Strworktimestart = item.StrDate[0]
                    item.Strworktimeend = item.StrDate[1]
                    // item.Strworktime = year+months+days+hours+minutes
                }
            })
            // 所有技能
            let allSkills = this.skillList.concat(this.certList)
            // console.log('saveEnterHandle', this.basicQuery,this.skillList,this.certList,this.eduExpList,this.workExpList)
            this.$refs['enterResumeForm'].validate((valid) => {
                if (valid) {
                xz.saveResumeinfo(this.basicQuery,allSkills,this.eduExpList,this.workExpList).then(res => {
                    // console.log('saveEnterHandle', res)
                    if (res.status == 'ok') {
                        if(this.saveType == 'all'){
                            this.isDetail = true;
                            this.editTxt = '编辑'
                        }
                        // 获取详情
                        this.getResumeDtl(this.basicQuery.ResumeId)
                        this.$message({ type: 'success', message: '操作成功' })
                        this.skillList = []
                        this.certList = []
                        this.eduExpList = []
                        this.workExpList = []
                    }else{
                    this.$message({ type: 'error', message: res.msg })
                    }
                })
                } else {
                return false;
                }
            })
        },
        // 删除各项
        dltAllHandle(id,type){
            this.dltQuery.strid = id
            this.dltQuery.strtype = type
            this.$confirm('是否确定删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                xz.delresumepro(this.dltQuery).then(res => {
                    // console.log('saveEnterHandle', res)
                    if (res.status == 'ok') {
                        // 获取详情
                        this.getResumeDtl(this.basicQuery.ResumeId)
                        this.$message({ type: 'success', message: '操作成功' })
                    }else{
                        this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                    }
                })
            }).catch(() => {
                console.log('已取消')
            })
        },
        // 新增工作经历
        addWorkHandle(){
            this.workExpList.push({
                Strworkid:'', //id
                StrProName:'', //公司名称
                StrJobInf:'', //岗位
                StrRemark:'', //离职原因
                StrDate:[],
                Strworktimestart:'', //开始
                Strworktimeend:'', //结束
                Strworktime:'' //工作时长
            });
        },
        // 新增教育经历
        addEduHandle(){
            this.eduExpList.push({
                Streduid:'', //id
                Strschool:'', //学校
                Strmajor:'', //专业
                StrRemark:'', //备注
                StrDate:[],
                Stredutimestart:'', //开始时间
                Stredutimeend:'' //结束时间
            });
        },
        // 新增证书
        addCertHandle(){
            this.certList.push({
                Strkillid:'', //id
                Strkilltype:'2', //1  技能  2 证书
                StrkillName:'', //名称
                StrkillNameTxt:'', //名称
                Enclosure:'', //附件
                fileReceiptList:[]
            });
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择上传 1 个文件`);
        },
        // 新增技能
        addSkillHandle(){
            this.skillList.push({
                Strkillid:'', //id
                Strkilltype:'1', //1  技能  2 证书
                StrkillName:'', //名称
                Enclosure:'' //附件
            });
        },
        // 删除
        dltSpendHandle(data,index){
            data.splice(index, 1)
        },
        // 证书上传附件
        handleReceiptChange(file, fileList, index) {
            // empexcel 对应 Excel  // docinf
            // bdocinf     对应 doc/pdf等
            // entimg      对应 图片类
            // usrvidoe   对应 视频类
            let formData = new FormData()
            formData.append("action", 'save')
            formData.append("pagename", 'bdocinf')
            formData.append("userid", Cookies.get("userid-b"))
            formData.append("entid", Cookies.get("userid-b"))
            formData.append("entPicFile", file.raw, file.name)
            this.certList[index].fileReceiptList = fileList
            // this.gapQuery.StrEnclosureName = file.name
            console.log('entPicFile', file, this.fileReceiptList)
            xz.uploadCert(formData).then(res => {
                // console.log('entPicFile', res)
                if (res) {
                this.certList[index].Enclosure = res
                } else {
                this.$message('文件上传失败,请稍后再试')
                }
            })
        },
        handleReceiptRemove(file, fileList, index) {
            this.certList[index].Enclosure = ''
            this.certList[index].fileReceiptList = fileList
            // console.log('file', this.infoList)
        },
        //选择地址
        changeArea(val) {
            // console.log('ddd', val)
            let checkedNode;
            let labels;
            if(!this.isNull(val)){
                checkedNode = this.$refs["cascaderArr"].panel.getNodeByValue(val);
                labels = checkedNode.pathLabels;
                // console.log( checkedNode ) ;  //获取当前点击节点的label值
                // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
                this.basicQuery.StrUserCityCode = val.toString()
                this.basicQuery.StrUserCity = labels.join('-')
            }else{
                this.basicQuery.StrUserCityCode = ''
                this.basicQuery.StrUserCity = ''
            }
            this.basicQuery.strCityCode = val
        },
        // 岗位类别选择
        poSectionChange(val){
            // console.log('poSectionChange', val)
            const checkedNode =  this.$refs['poSectionArr'].getCheckedNodes();
            // console.log( checkedNode[0].data.strParametername ) ;  //获取当前点击节点的label值
            // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
            if(!this.isNull(val)){
                let labels = checkedNode[0].pathLabels;
                if(labels.length > 1){
                    this.basicQuery.StrJobInf = labels[0] + '-' + labels[1];
                }else if(labels.length == 1){
                    this.basicQuery.StrJobInf = labels[0];
                }
            }else{
                this.basicQuery.StrJobInf = ''
                this.basicQuery.posCategoryList = []
            }
        },
        // 保存标签
        saveLabelHandle(){
            this.diaTagChecks = this.dCheckPriLabelList.concat(this.dCheckCommonLabelList)
            //去重
            this.diaTagChecks = [...new Set(this.diaTagChecks)];
            let ids = this.diaTagChecks.toString()
            // console.log('uuu',this.basicQuery.ResumeId, ids)
            if(this.isNull(this.diaTagChecks)){
                this.$message({ type: 'warning', message: '请选择标签' })
                return false
            }else{
                this.tagHandle({resumeIds:this.basicQuery.ResumeId,labelIds:ids})
            }
        },
        // 打标签
        tagHandle(query){
            // console.log('tagHandle', query)
            xz.savelabelResume(query).then(res => {
                console.log('tagHandle', res)
                if (res.status == 'ok') {
                this.addlabelVisible = false
                this.getresumelabelLists(this.basicQuery.ResumeId)
                this.$message({ type: 'success', message: '操作成功' })
                }else{
                this.$message({ type: 'error', message: '操作失败,请稍后再试' })
                }
            })
        },
        handleLabelClick(tab){},
         // 标签弹框 选择公有标签
        dPubEnterHandle(val){
            this.dCheckCommonLabelList = []
            // console.log('labelEnterHandle', val)
            this.dCheckCommonLabelList = val
        },
        // 标签弹框 选择私有标签
        dPraEnterHandle(val){
            this.dCheckPriLabelList = []
            // console.log('lPraEnterHandle', val)
            this.dCheckPriLabelList = val
        },
        // 添加标签弹框
        addLabelHandle(){
            this.GetLabelManagement()
            // 全局标签
            for (let i = 0; i < this.lPubDialogList.length; i++) {
                const elementl1 = this.lPubDialogList[i];
                this.wholeCheckList.push(elementl1.LabelId)
            }
            // 私有
            for (let j = 0; j < this.lPriDialogList.length; j++) {
                const elementl2 = this.lPriDialogList[j];
                this.wholeCheckList2.push(elementl2.LabelId)
            }
            this.dCheckPriLabelList = this.wholeCheckList2
            this.dCheckCommonLabelList = this.wholeCheckList
            this.diaTagChecks = this.wholeCheckList.concat(this.wholeCheckList2)
            this.addlabelVisible = true
        },
        // 点击更换头像
        handleAvatarSuccess(res, file) {
        // console.log('file', res, file)
        // 连接后台服务器
        // this.staffQuery.imageUrl = URL.createObjectURL(file.raw)
        },
        beforeAvatarUpload(file) {
        const isJPG = file.type === "image/jpeg"
        const isLt2M = file.size / 1024 / 1024 < 2
        //   if (!isJPG) {
        //     this.$message.error("上传头像图片只能是 JPG 格式!")
        //   }
        if (!isLt2M) {
            this.$message.error("上传头像图片大小不能超过 2MB!")
        }
        //  return isJPG && isLt2M
            return isLt2M
        },
        upLoad(file) {
            // 通过form数据格式来传
            const formData = new FormData()
            // formData.append("file", file)
            formData.append('userid', Cookies.get('userid-b'))
            formData.append('entid', Cookies.get('userid-b'))
            formData.append('pagename', 'entimg')
            formData.append('action', 'save')
            formData.append("entPicFile", file.raw, file.name)
            // 此时的formData可通过formData.get("file_name")查看添加的参数
            // console.log("file_name",formData.get("file"))
            uploadAvatar(formData).then((res) => {
                // console.log(res)
                if (res) {
                this.staffQuery.Stravatar = res
                } else {
                this.$message('头像上传失败,请稍后再试')
                }
            })            
        },
        // 返回
        backHandle(){
            this.$router.back()
            // this.$router.go(-1) // 后退+刷新
        },
        // 编辑
        editHandle(){
            this.isDetail = !this.isDetail
            if(this.isDetail){
                this.editTxt = '编辑'
            }else{
                this.editTxt = '保存编辑'
            }
        },
        // 人岗匹配岗位 岗位类别
        getTreestr() {
            let data = {
                currpage: 1,
                perpage: 10000,
                strIsDisable:'', // 传1 禁用的看不到了  不传就全显示
                keyword: ''
            }
            xz.getTreestr('JB_base_Jobcategory', data).then(res => {
                if (res) {
                this.intendedPost = res.msg.parent
                } else {
                this.intendedPost = []
                }
            })
        },
        // 下载附件
        downloadFile(url){
            let path = this.docPath + url
            this.download(path)
        },
        download(url) {
            // console.log('url',url)
            const link = document.createElement('a')
            // a.download = name
            link.href = url
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        // 获取简历详情
        getResumeDtl(id){
            this.formLoading = true
            xz.getResumeDetail({ResumeId: id}).then(res => {
                // console.log('getResumeDtl', res)
                if (res.status == 'ok') {
                    let resMsg = res.msg
                    let resMsgp = res.msgp
                    this.strIdCardTxt = resMsg.StrIdCard
                    this.basicQuery = {
                        natureId:resMsgp.GdPsnId, //自然人ID GdPsnId
                        enterUser:resMsgp.Creator, // 录入人
                    ResumeId: resMsg.ResumeId, //简历ID
                    StrUserName: resMsg.StrUserName, //姓名
                    StrMobile: resMsg.StrMobile, //联系方式
                    StrWorkState: resMsg.StrWorkState, //在离职状态
                    BolUserSex: resMsg.BolUserSex, //性别
                    StrUserAge: resMsg.StrUserAge, //年龄
                    StrNativePlace: resMsg.StrNativePlace, //户籍
                    StrEduLvl: resMsg.StrEduLvl, //学历
                    StrJobInf: resMsg.StrJobInf, //意向岗位
                    StrCategoryIds: resMsg.StrCategoryIds, //意向岗位id
                    // 选中的意向岗位
                    posCategoryList: resMsg.StrCategoryIds?resMsg.StrCategoryIds.split(','):[],
                    StrUserCity: resMsg.StrUserCity, //求职城市
                    StrUserAdd: resMsg.StrUserAdd, //居住地
                    StrUserCityCode: resMsg.StrUserCityCode, //求职城市code
                    StrSource: resMsg.StrSource, //来源
                    StrUserExpectSa: resMsg.StrUserExpectSa, //期望薪资
                    salary1: !this.isNull(resMsg.StrUserExpectSa)?resMsg.StrUserExpectSa.split('-')[0]:'',
                    salary2: !this.isNull(resMsg.StrUserExpectSa)?resMsg.StrUserExpectSa.split('-')[1]:'',
                    StrRemark: resMsg.StrRemark, //备注
                    StrlateCompany: resMsg.StrlateCompany, //最近入职项目
                    DtlateInducDate: !this.isNull(resMsg.DtlateInducDate)?resMsg.DtlateInducDate:'', //最近入职时间
                    DtlatequitDate: !this.isNull(resMsg.DtlatequitDate)?resMsg.DtlatequitDate:'', //最近离职时间
                    StrquitReason: resMsg.StrquitReason, //离职原因
                    StrUserJobhunt: resMsg.StrUserJobhunt, //求职意向
                    StrPsnIsType: resMsg.StrPsnIsType, //是否公海 1 公海 0私人
                    enterDate: resMsg.DtInsertDate, //录入时间
                    StrJobType: resMsg.StrJobType, //岗位类型
                    StrState: resMsg.StrState, //状态
                    DtupdateDate: resMsg.DtupdateDate,
                    // 选中的地区code
                    strCityCode: resMsg.StrUserCityCode?resMsg.StrUserCityCode.split(',').map(Number):[],
                    //拓展
                    StrIsBlack: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrIsBlack)?resMsgp.StrIsBlack:'', //是否黑名单
                    StrBlackReason: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrBlackReason)?resMsgp.StrBlackReason:'', //黑名单原因
                    StrUsernation: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrUsernation)?resMsgp.StrUsernation:'', //民族
                    Strskill: !this.isNull(resMsgp)&&!this.isNull(resMsgp.Strskill)?resMsgp.Strskill:'', //技能
                    Strcertificate: !this.isNull(resMsgp)&&!this.isNull(resMsgp.Strcertificate)?resMsgp.Strcertificate:'', //证书
                    StrAccomreq: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrAccomreq)?resMsgp.StrAccomreq:'', //住宿要求
                    StrDinreq: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrDinreq)?resMsgp.StrDinreq:'', //吃饭要求
                    StrIsqwfri: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrIsqwfri)?resMsgp.StrIsqwfri:'', //是否企微好友
                    StrCont1: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont1)?resMsgp.StrCont1:'', //拓展1
                    StrCont2: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont2)?resMsgp.StrCont2:'',
                    StrCont3: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont3)?resMsgp.StrCont3:'',
                    StrCont4: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont4)?resMsgp.StrCont4:'',
                    StrCont5: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont5)?resMsgp.StrCont5:'',
                    StrCont6: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont6)?resMsgp.StrCont6:'',
                    StrCont7: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont7)?resMsgp.StrCont7:'',
                    StrCont8: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont8)?resMsgp.StrCont8:'',
                    StrCont9: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont9)?resMsgp.StrCont9:'',
                    StrCont10: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont10)?resMsgp.StrCont10:'',
                    Strsocial:resMsgp.Strsocial,//社保需求
                    Strother:resMsgp.Strother, // 政治面貌
                    WorkingShift: resMsgp.WorkingShift, // 班次
                    Workingposition: resMsgp.Workingposition, // 站班/坐班
                    StrResumefile: resMsg.StrResumefile, // 简历附件名称
                    StrResumefileUrl: resMsg.StrResumefileUrl // 简历附件路径
                    }
                    if(!this.isNull(resMsg.StrResumefileUrl)){
                        this.vitafileList = [{
                            name: resMsg.StrResumefile,
                            url: resMsg.StrResumefileUrl
                        }]
                    }else{
                        this.vitafileList = []
                    }
                    // 意向岗位
                    if(!this.isNull(resMsg.StrJobInf)){
                        let posArrVal = this.getPath(
                            this.intendedPost,
                            resMsg.StrJobInf
                        );
                        // console.log('posArrVal', posArrVal)
                        if(posArrVal.length>1){
                            this.basicQuery.posCategoryList = [posArrVal[0].strParameterid,posArrVal[1].strParameterid]
                        }else if(posArrVal.length==1){
                            this.basicQuery.posCategoryList = [posArrVal[0].strParameterid]
                        }
                    }
                    if(!this.isNull(resMsg.StrUserCity)){
                        this.$nextTick(() => {
                            // console.log('posArrVal', this.$refs.cascaderArr)
                            let areaVal = resMsg.StrUserCity
                            this.$refs[`cascaderArr`].inputValue = areaVal.split('-').join('/')
                        })
                    }
                    // 技能
                    this.skillData = res.msgkill;
                    // 证书
                    this.certData = res.msgkill2;
                    // 教育经历
                    this.eduData = res.msgedu;
                    // 工作经历
                    this.workData = res.msgwork;
                }
                this.formLoading = false
            });
        },
        //获取多级下拉选项(证书选择列表)
        GetDictDataTreeListById(Id, list) {
            xz.GetDictDataTreeListById(Id).then(res => {
                if (res.status == 'ok') {
                this[list] = res.data.inf;
                } else {
                this[list] = [];
                }
            })
        },
        //参数列表（班次、坐班站班）
        getdictdatalistbyid(id) {
            xz.getdictdatalistbyid(id).then(res => {
                // console.log('getdictdatalistbyid', res)
                if (res.status == 'ok') {
                if(id == '70'){
                    // 班次
                    this.shiftList = res.data.retList
                }
                if(id == '67'){
                    // 坐班站班
                    this.workList = res.data.retList
                }
                // if(id == '44'){
                //     // 是否包住
                //     this.stayList = res.data.retList
                // }
                // if(id == '57'){
                //     // 是否包吃
                //     this.eatList = res.data.retList
                // }
                if(id == '141'){
                    // 学历要求
                    this.eduList = res.data.retList
                }
                  if(id == '253'){
                    // 民族要求
                    this.nationList = res.data.retList
                  }
                if(id == '118'){
                    // 简历来源
                    this.originList = res.data.retList
                }
                if(id == '160'){
                        // 政治面貌
                        this.politicsList = res.data.retList
                    }
                }
                if(id == '132'){
                    // 黑名单标签
                    this.blackLabelList = res.data.retList
                }
            })
        },
        // 根据级联选择器最后一级选中的值回显整个选中的数组  即通过最后一级的id 获取整个路径的数组
        getPath(treeData, targetId) {
            //  console.log(221, treeData, targetId);
            let path = [];
            let toggle = false;
            for (let i = 0; i < treeData.length; i++) {
                let item = treeData[i];
                path.push({
                    strParametername:item.strParametername,
                    strParameterid:item.strParameterid
                });
                if (item.strParametername === targetId) {
                toggle = true;
                break;
                } else {
                if (item.children) {
                    toggle = this.findPath(item.children, targetId, path, toggle);
                    if (!toggle) {
                    path.pop();
                    } else {
                    break;
                    }
                } else {
                    path.pop();
                }
                }
            }
            if (toggle) {
                // console.log(245, path);
                return path;
            } else {
                return [];
            }
        },
        findPath(nodes, targetId, path, toggle) {
            for (let i = 0; i < nodes.length; i++) {
                let item = nodes[i];
                path.push({
                    strParametername:item.strParametername,
                    strParameterid:item.strParameterid
                });
                if (item.strParametername === targetId) {
                    return true;
                } else {
                    if (item.children) {
                        toggle = this.findPath(item.children, targetId, path, toggle);
                        if (toggle) {
                        return toggle;
                        } else {
                        path.pop();
                        }
                    } else {
                        path.pop();
                    }
                }
            }
            return toggle;
        },
        //获取省份
        getprovinces() {
            xz.getAreaAll().then(res => {
                // console.log('getprovinces', res)
                // if (res.status == 'ok') {
                this.provinces = res;
                // } else {
                // this.provinces = [];
                // }
            })
        },
        //获取标签列表
        GetLabelManagement() {
            this.laloading = true;
            this.publicList = []
            this.privateList = []
            xz.GetLabelManagement(this.roleType).then(res => {
                if (res.status == 'ok') {
                this.publicList = res.data.PublicPersonList;
                this.privateList = res.data.PrivatelyList;
                }
                this.laloading = false;
            })
        },
        // 获取简历标签详情
        getresumelabelLists(resumeId){
            this.includePublicChecks = []
            this.includePrivateChecks = []
            xz.GetresumelabelLists({resumeId: resumeId}).then(res => {
                // console.log('getresumelabelLists', res)
                if (res.status == 'ok') {
                    this.lPubDialogList = res.msgpub
                    this.lPriDialogList = res.msgpri
                    // 公共标签
                    if(!this.isNull(res.msgpub)){
                    for (let i = 0; i < res.msgpub.length; i++) {
                        const elementpub = res.msgpub[i];
                        this.includePublicChecks.push(elementpub.LabelId)
                    }
                    }
                    // 私有标签
                    if(!this.isNull(res.msgpri)){
                    for (let j = 0; j < res.msgpri.length; j++) {
                        const elementpri = res.msgpri[j];
                        this.includePrivateChecks.push(elementpri.LabelId)
                    }
                    }
                }
            })
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
        }
    }
}
</script>

<style>
.r_edit_content02 .el-upload-list{
    max-width: 500px;
}
.r_edit_content02 .el-upload-list__item:first-child{
    margin-top: 0;
}
.r_edit_content .r_spend_box tbody tr{
    color:#333;
}
.r_edit_content .r_spend_box .s_input{
    width: 200px;
}
.r_edit_content .r_spend_box .el-date-editor--daterange.el-input__inner{
    width: 260px!important;
    margin-right: 8px;
}
/* .r_edit_content .el-input.is-disabled .el-input__inner{
    background-color: #fff;
    border: none;
    cursor: default;
}
.r_edit_content .el-input.is-disabled .el-input__icon{
    display: none;
} */
.r_edit_content .p_plan_upload{
    display: flex;
    align-items: center;
}
.r_edit_content .r_spend_box .el-upload-list__item:first-child{
    margin-top: 0;
}
.r_qiwei .el-image__inner{
    width: 30px;
    height: 20px;
    margin-left: 10px;
}
.s_input{
    margin-right: 8px;
}
.r_edit_content .el-form-item__label{
    color:#7F7F7F;
}
</style>
<style scoped>
.id_txt{
    font-size: 14px;
    margin-left: 20px;
    margin-top: 6px
}
.r_edit_content .r_title_btns{
    display: flex;
    flex-wrap: wrap;
    flex:1;
    justify-content: flex-end;
}
.r_edit_content .p_vita_upload{
    display: flex;
    align-items: center;
    margin-right: 10px;
}
.com_title{
    color:#7F7F7F;
}
.inten_box{
    margin-top: 10px;
}
.inten_list{
    display: flex;
    flex-wrap: wrap;
}
.inten_item{
    display: flex;
    align-items: center;
    margin-bottom: 17px;
}
.inten_item_left{
    width: 100px;
    font-size: 14px;
    color: #7F7F7F;
    line-height: 25px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
}
.inten_item_right{
    width: 210px;
    line-height: 25px;
    font-size: 14px;
    color:#333;
}
.icon_add{
    display: inline-block;
    font-size: 20px;
    color:#409EFF;
    margin-left:10px;
    cursor: pointer;
}
.dlt_icon{
    display: inline-block;
    font-size: 18px;
    color:#999;
    margin-left:10px;
    cursor: pointer;
}
.r_basic_content{
    margin-bottom: 10px;
}
.r_spend_form{
    margin-top: 10px;
    margin-bottom: 20px;
}
.r_btn_box{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}
.s_file_txt{
    color:#409EFF;
    font-size: 13px;
    margin-left: 5px;
    cursor: pointer;
}
.s_content{
    margin-top: 5px;
}
.r_spend_item01{
    display: flex;
    align-items: center;
}
.r_spend_skill{
    display: flex;
    flex-wrap: wrap;
}
.r_spend_btn{
    width: 90px;
}
.r_spend_model{
    position: relative;
    margin-right: 20px;
    display: flex;
    align-items: center;
}
.r_spend_model i{
    position: absolute;
    right: -10px;
    top: -6px;
    font-size: 16px;
    color:#999;
    cursor: pointer;
    z-index: 1;
}
.r_spend_list{
    display: flex;
    /* align-items: center; */
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.r_spend_title{
    font-size: 14px;
    color:#7F7F7F;
    margin-right: 20px;
    margin-top: 4px;
}
.r_spend_txts{
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    color:#333;
    /* flex: 1; */
}
.r_spend_txts span{
    margin-right: 10px;
}
.r_edit_content .r_line_box .el-input{
  width: 98px;
}
.r_line_box{
  display: flex;
  align-items: center;
}
.r_line_txt{
  width: 4px;
  height: 1px;
  background-color: #DCDFE6;
  margin: 0 5px;
}
.r_label_btn{
    width: 90px;
    text-align: right;
}
.r_label_list{
    display: flex;
    flex-wrap: wrap;
}
.r_label_item{
    padding: 2px 10px;
    background-color: #f2f2f2;
    margin-right: 10px;
    margin-bottom: 5px;
}
.r_label_box{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}
.r_label_left{
    display: flex;
    /* justify-content: space-between; */
    /* flex: 1; */
}
.l_box{
    flex: 1;
}
.r_label_right{
    width: 150px;
    text-align: center;
}
.r_basic_left{
    flex: 1;
}
.r_basic_right{
    width: 120px;
    text-align: center;
}
.r_basic_box{
    display: flex;
    justify-content: space-between;
}
.r_lefts{
    display: flex;
    flex-wrap: wrap;
}
.l_info_box{
    display: flex;
    flex-wrap: wrap;
}
.r_left_info{
    font-size: 14px;
    color: #333;
    margin-left: 20px;
}
.r_txts i{
    font-size: 18px;
    color:#333;
}
.r_txts.r_txts01{
    margin-top: 8px;
}
.r_txt04{
    font-size: 14px;
    color:#000;
    font-weight: bold;
}
.r_txts{
    margin-top: 6px;
}
.r_txt01{
    margin-right: 5px;
}
.r_txt03{
    margin-left: 10px;
}
.r_txt05{
    margin-top: 12px;
    color:#999;
    font-size: 14px;
}
.r_txt06{
    color:#333;
    font-size: 14px;
}
.r_txt07{
    color:#333;
    font-size: 14px;
    margin-bottom: 5px;
}
.r_qiwei{
    display: flex;
    align-items: center;
}
.r_qiwei p{
    font-size: 16px;
    color:#000;
    font-weight: bold;
}
.r_left_pic{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 110px;
    height: 100px
}
.pic_item{
    width: 110px;
    height: 100px
}
.f_form_btn{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
}
.r_edit_title{
    width: 100px;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color:#aaa;
}
</style>